// extracted by mini-css-extract-plugin
export default {"icon":"GetVmStatusButton_icon__7lfGe"};